module.exports = __webpack_public_path__ + "img/Girl_020034.cc791785.png";